import type { Study, ConcentrationTimePoint } from '@bioavail/shared-types';
import { createArm, createStudy } from '../factory';
import {
  RouteOfAdministration as ROA,
  ArmRole as AR,
  DoseUnit as DU,
  ConcentrationUnit as CU,
  TimeUnit as TU,
  CalculationMode as CM,
  AucInterval as AI,
} from '@bioavail/shared-types';

/**
 * Worked example: warning case — sparse sampling + high extrapolation.
 * Demonstrates validation warnings (F-038/F-039) firing.
 */
export function warningCaseExample(): Study {
  const sparse: ConcentrationTimePoint[] = [
    { time: 1, concentration: 400, isBlq: false },
    { time: 4, concentration: 180, isBlq: false },
    { time: 8, concentration: 90, isBlq: false },
    { time: 12, concentration: 60, isBlq: false },
  ];
  const ref: ConcentrationTimePoint[] = [
    { time: 0.5, concentration: 900, isBlq: false },
    { time: 1, concentration: 620, isBlq: false },
    { time: 2, concentration: 340, isBlq: false },
    { time: 4, concentration: 120, isBlq: false },
    { time: 8, concentration: 18, isBlq: false },
    { time: 12, concentration: 2.6, isBlq: false },
    { time: 16, concentration: 0.35, isBlq: false },
  ];
  return createStudy({
    name: 'Example — Warning Case (sparse sampling)',
    mode: CM.Absolute,
    aucInterval: AI.ZeroToInf,
    arms: [
      createArm({ id: 'arm-test', label: 'Oral (sparse)', route: ROA.Oral, role: AR.Test, dose: 200, doseUnit: DU.Mg, concentrationUnit: CU.NgPerMl, timeUnit: TU.Hour, dataPoints: sparse }),
      createArm({ id: 'arm-ref', label: 'IV reference', route: ROA.IV, role: AR.Reference, dose: 100, doseUnit: DU.Mg, concentrationUnit: CU.NgPerMl, timeUnit: TU.Hour, dataPoints: ref }),
    ],
  });
}
